<div class="popup" in:fly={{x:-100*dir}}>
  <div class="desc">
    <h3>{project.title}</h3>
    <p>{project.desc} {#if project.more}<a href={project.more} target="_blank">Learn more.</a>{/if}</p>
  </div>
  <div class="img">    
    <iframe title={project.title} scrolling="no" src="/res/animations/{project.img}" allowtransparency="true"></iframe>
  </div>
</div>

<style type="text/scss">
.popup{
  display:flex;

  h3{ font-size:30px; font-weight:700; color:white; padding-bottom:10px; width:70%; line-height:35px; }

  p{
    a{
      text-decoration:underline;
    }
  }

  & > div{
    width:50%;
    text-align:left;
  }
  & > div.img{
    order:1;
    text-align:right;
    iframe{ width:370px; height:350px; margin-right:20px; margin-top:20px; margin-bottom:20px; border:none; overflow:hidden; }
  }
}
.desc{
  font-size:16px;
  order:2;
  padding:20px;
  line-height:27px;
  color:#9acaeb;
  justify-content:center;
  display:flex;
  flex-direction:column;
  p{ width:80%; }
}
@media( max-width:1024px ){
  .popup{
    flex-direction:column;
    h3{ width:100%; }
    & > div{
      display:flex;      
      width:100%;
      align-items:center;      
      padding:0px;
      margin:0px;
      &.desc{
        width:70%;
        margin:0px auto;
      }
    }
    & > div.img{
      flex-direction:row-reverse;
      transform:scale(0.8);
      justify-content:center;
      iframe{ width:100%; height:350px; margin:0px; }
    }
  }
  .desc{
    padding:0px 20px;
    p{ width:100%; }
  }
}
</style>

<script>
import { fly } from 'svelte/transition'

export let project
export let dir = 1
</script>